export default "__VITE_ASSET__D_ZH0OAG__"